/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAdminUserWalletPageListRespVo
 */
export interface GetAdminUserWalletPageListRespVo {
    /**
     * 用户 ID，关联用户表主键
     * @type {number}
     * @memberof GetAdminUserWalletPageListRespVo
     */
    userId?: number;
    /**
     * 会员名称
     * @type {string}
     * @memberof GetAdminUserWalletPageListRespVo
     */
    name?: string;
    /**
     * 用户账号
     * @type {string}
     * @memberof GetAdminUserWalletPageListRespVo
     */
    code?: string;
    /**
     * 中国钱包 ID
     * @type {number}
     * @memberof GetAdminUserWalletPageListRespVo
     */
    chinaWalletId?: number;
    /**
     * 韩国钱包 ID
     * @type {number}
     * @memberof GetAdminUserWalletPageListRespVo
     */
    koreaWalletId?: number;
    /**
     * 预存款余额-中国用（可为负数）
     * @type {number}
     * @memberof GetAdminUserWalletPageListRespVo
     */
    chinaAmount?: number;
    /**
     * 预存款余额-韩国用（可为负数）
     * @type {number}
     * @memberof GetAdminUserWalletPageListRespVo
     */
    koreaAmount?: number;
    /**
     * 预存款冻结金额-韩国用
     * @type {number}
     * @memberof GetAdminUserWalletPageListRespVo
     */
    koreaFreezeAmount?: number;
    /**
     * 透支额度-中国用（可为负数）
     * @type {number}
     * @memberof GetAdminUserWalletPageListRespVo
     */
    chinaOverdraftLimit?: number;
    /**
     * 透支额度-韩国用（可为负数）
     * @type {number}
     * @memberof GetAdminUserWalletPageListRespVo
     */
    koreaOverdraftLimit?: number;
}

/**
 * Check if a given object implements the GetAdminUserWalletPageListRespVo interface.
 */
export function instanceOfGetAdminUserWalletPageListRespVo(value: object): value is GetAdminUserWalletPageListRespVo {
    return true;
}

export function GetAdminUserWalletPageListRespVoFromJSON(json: any): GetAdminUserWalletPageListRespVo {
    return GetAdminUserWalletPageListRespVoFromJSONTyped(json, false);
}

export function GetAdminUserWalletPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdminUserWalletPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'chinaWalletId': json['chinaWalletId'] == null ? undefined : json['chinaWalletId'],
        'koreaWalletId': json['koreaWalletId'] == null ? undefined : json['koreaWalletId'],
        'chinaAmount': json['chinaAmount'] == null ? undefined : json['chinaAmount'],
        'koreaAmount': json['koreaAmount'] == null ? undefined : json['koreaAmount'],
        'koreaFreezeAmount': json['koreaFreezeAmount'] == null ? undefined : json['koreaFreezeAmount'],
        'chinaOverdraftLimit': json['chinaOverdraftLimit'] == null ? undefined : json['chinaOverdraftLimit'],
        'koreaOverdraftLimit': json['koreaOverdraftLimit'] == null ? undefined : json['koreaOverdraftLimit'],
    };
}

export function GetAdminUserWalletPageListRespVoToJSON(json: any): GetAdminUserWalletPageListRespVo {
    return GetAdminUserWalletPageListRespVoToJSONTyped(json, false);
}

export function GetAdminUserWalletPageListRespVoToJSONTyped(value?: GetAdminUserWalletPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'name': value['name'],
        'code': value['code'],
        'chinaWalletId': value['chinaWalletId'],
        'koreaWalletId': value['koreaWalletId'],
        'chinaAmount': value['chinaAmount'],
        'koreaAmount': value['koreaAmount'],
        'koreaFreezeAmount': value['koreaFreezeAmount'],
        'chinaOverdraftLimit': value['chinaOverdraftLimit'],
        'koreaOverdraftLimit': value['koreaOverdraftLimit'],
    };
}

